<div class="zone-selector">
  <div class="zone-selector-header">
    <h3>
      <i class="fas fa-map-marked-alt"></i>
      Zonas
    </h3>
    <button *ngIf="canCreate" type="button" class="btn-new-zone" (click)="onCreateZone()" title="Nueva zona">
      <i class="fas fa-plus"></i>
      Nueva zona
    </button>
  </div>
  <div class="zones-list">
    <div
      *ngFor="let zone of zones"
      class="zone-row"
      [class.active]="zone.id === selectedZoneId"
      (click)="selectZone(zone.id)">
      <button type="button" class="zone-btn">
        <i [class]="'fas ' + getZoneIcon(zone.type) + ' zone-icon'"></i>
        <span class="zone-name">{{ zone.name }}</span>
        <span class="zone-count">{{ getZoneTableCount(zone.id) }}</span>
      </button>
      <button
        *ngIf="canEdit"
        type="button"
        class="btn-delete-zone"
        (click)="onDeleteZone(zone); $event.stopPropagation()"
        title="Eliminar zona">
        <i class="fas fa-trash-alt"></i>
      </button>
    </div>
  </div>
</div>
